var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 15.8333V18.3333H1.66699V15.8333C1.66699 15.375 2.04199 15 2.50033 15H17.5003C17.9587 15 18.3337 15.375 18.3337 15.8333Z",
    fill: "#86A7C3",
    stroke: "#86A7C3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66699 14.5V9.66666H5.33366V14.5H4.66699Z",
    fill: "#86A7C3",
    stroke: "#86A7C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.5V9.66666H8.66667V14.5H8Z",
    fill: "#86A7C3",
    stroke: "#86A7C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 9.16666H10.833V15H12.4997V9.16666Z",
    fill: "#86A7C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 9.16666H14.167V15H15.8337V9.16666Z",
    fill: "#86A7C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1663 18.9583H0.833008C0.491341 18.9583 0.208008 18.675 0.208008 18.3333C0.208008 17.9917 0.491341 17.7083 0.833008 17.7083H19.1663C19.508 17.7083 19.7913 17.9917 19.7913 18.3333C19.7913 18.675 19.508 18.9583 19.1663 18.9583Z",
    fill: "#86A7C3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8087 4.79167L10.3087 1.79167C10.142 1.725 9.85866 1.725 9.69199 1.79167L2.19199 4.79167C1.90033 4.90834 1.66699 5.25 1.66699 5.56667V8.33334C1.66699 8.79167 2.04199 9.16667 2.50033 9.16667H17.5003C17.9587 9.16667 18.3337 8.79167 18.3337 8.33334V5.56667C18.3337 5.25 18.1003 4.90834 17.8087 4.79167ZM10.0003 7.08334C9.30866 7.08334 8.75033 6.525 8.75033 5.83334C8.75033 5.14167 9.30866 4.58334 10.0003 4.58334C10.692 4.58334 11.2503 5.14167 11.2503 5.83334C11.2503 6.525 10.692 7.08334 10.0003 7.08334Z",
    fill: "#86A7C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.c66948d1.svg";
export { ForwardRef as ReactComponent };